var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBigWarning(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    fill: "#BF3F3F",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M27.8656 10.0512C26.1476 7.07539 21.8524 7.0754 20.1344 10.0512L6.60467 33.4853C4.88662 36.461 7.03419 40.1807 10.4703 40.1807H37.5297C40.9658 40.1807 43.1134 36.461 41.3953 33.4853L27.8656 10.0512ZM22.179 27.7479L21.429 16.8193H25.929L25.179 27.7479H22.179ZM26.5718 32.2477C26.5718 33.6679 25.4205 34.8191 24.0003 34.8191C22.5802 34.8191 21.4289 33.6679 21.4289 32.2477C21.4289 30.8275 22.5802 29.6763 24.0003 29.6763C25.4205 29.6763 26.5718 30.8275 26.5718 32.2477Z",
    fill: ""
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBigWarning);
export default __webpack_public_path__ + "static/media/big-warning.c31fc7aa7840e8018cb68e6baa73e529.svg";
export { ForwardRef as ReactComponent };